import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { tap } from 'rxjs';
import { BugsnagService } from './bugsnag.service';

@Injectable()
export class BugsnagEffects {
  actionBreadcrumbs$ = createEffect(
    () =>
      this.actions.pipe(tap((action) => this.bugsnagService.leaveBreadcrumb('DISPATCH:NGRX', { type: action.type }))),
    { dispatch: false }
  );

  constructor(private actions: Actions, private bugsnagService: BugsnagService) {}
}
